<template>
  <div class="meta_box">
    <el-row :gutter="0">
      <el-col :xs="24">
        <div class="descp1">
          {{ $t('promotion.referFriends.title_v2', { amount: formattedRedeemLimit }) }}
        </div>
        <div class="descp2">
          {{ $t('promotion.referFriends.subtitle_v2', { amount: formattedRedeemLimit, dayLimit: '60' }) }}
        </div>
        <div class="descp2">
          <i18n path="promotion.referFriends.tnc_v2">
            <template v-slot:link>
              <a target="_blank" :href="tncLink">
                {{ $t('promotion.referFriends.link') }}
              </a>
            </template>
          </i18n>
        </div>
      </el-col>
    </el-row>
    <StepsSection :steps="stepProps" class="steps-section" />
    <section class="box-wrapper">
      <Redeem
        class="redeem"
        :totalAmount="total.amount"
        :refereeLimit="refereeLimit"
        :isDisabledRedeemButton="isDisabledRedeemButton"
        @clickRedeem="onClickRedeem"
      />
      <Referral :referralLink="referralLink" />
    </section>
  </div>
</template>

<script>
import { RAF_INDIA_TNC_LINK, RAF_TNC_LINK } from '@/constants/thirdPartyLink';
import StepsSection from './StepsSection.vue';
import Redeem from './Redeem.vue';
import Referral from './Referral.vue';
import { STATUS } from '../constants/voucher';
import { canRedeem as canRedeemOthers } from '../helpers/voucher';
import { canRedeem as canRedeemIndia } from '../helpers/voucherIndia';

export default {
  name: 'Overview',
  props: {
    participants: {
      type: Array,
      default: () => {
        return [];
      }
    },
    refereeLimit: {
      type: Number,
      default: () => {
        return 10;
      }
    },
    referralLink: {
      type: String
    },
    redeemLimit: {
      type: Number
    },
    referAFriendID: {
      type: Number
    },
    isRafIndia: {
      type: Boolean
    }
  },
  data() {
    return {
      stepProps: [
        {
          text: this.$t('promotion.referFriends.registerALiveAccount'),
          img: require(`@/assets/images/icon/register.png`)
        },
        {
          text: this.$t('promotion.referFriends.fundYourLiveAccount'),
          img: require(`@/assets/images/icon/live_account.png`)
        },
        {
          text: this.$t('promotion.referFriends.tradeWithin30Days'),
          img: require(`@/assets/images/icon/trade30days.png`)
        }
      ]
    };
  },
  components: {
    StepsSection,
    Redeem,
    Referral
  },
  computed: {
    tncLink() {
      return this.isRafIndia ? RAF_INDIA_TNC_LINK : RAF_TNC_LINK;
    },
    total() {
      return this.participants.slice(0, this.refereeLimit).reduce(
        (acc, { vouchers, participantId, tier, participantStatus }) => {
          const canRedeem = this.isRafIndia ? canRedeemIndia({ vouchers }) : canRedeemOthers({ vouchers, tier });
          if (canRedeem && participantStatus === 'VOUCHER_UNLOCKED') {
            acc.participants.push(participantId);
            acc.amount += vouchers.reduce((total, { amount, status }) => {
              if (status === STATUS.VALID) total += amount;
              return total;
            }, 0);
          }
          return acc;
        },
        { participants: [], amount: 0 }
      );
    },
    isDisabledRedeemButton() {
      let count = 0;

      for (const item of this.participants) {
        if (item.participantStatus === 'VOUCHER_UNLOCKED' && !this.isOverLimit(count)) {
          return false;
        }

        count++;
      }
    },
    formattedRedeemLimit() {
      if (!this.redeemLimit) {
        switch (this.referAFriendID) {
          case 50:
            return 200;
          case 54:
            return 25;
        }
      }
      return this.redeemLimit;
    }
  },
  methods: {
    onClickRedeem() {
      this.$emit('clickRedeem', this.total.participants, this.total.amount);
    },
    isOverLimit(index) {
      return index >= this.refereeLimit;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/overview/overview.scss';
</style>
